import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=1571f5f6&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&id=1571f5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571f5f6",
  null
  
)

export default component.exports